import styled from 'styled-components';
import { Card } from 'components/card/Card';

export const StyledCard = styled(Card).attrs({
  className: 'gap-0 py-0',
})``;

export const CardContent = styled.div.attrs({
  className: 'flex flex-col gap-3 px-3 py-2 w-full',
})``;

export const Topbar = styled.div.attrs({
  className: 'flex gap-1 items-center w-full',
})``;

export const PausedBadge = styled.div.attrs({
  className:
    'flex items-center justify-center rounded-sm px-1 py-0.5 bg-paused text-paused-foreground shrink-0',
})``;

export const TopbarInfo = styled.p.attrs({
  className: 'flex-1 min-w-0 text-xs text-muted-foreground',
})``;

export const ActionsBar = styled.div.attrs({
  className: 'flex items-start w-full px-3 py-2 border-t border-border',
})``;
